// import recentDataA from './data/feb2024/fasilkom.js'
// import recentDataB from './data/feb2024/fmipa.js'
// // import recentDataC from './data/feb2024/c.json'

// const allData = []

// recentDataA.forEach((student, index) => {
// 	allData.push({
// 		key: `_${index}`,
// 		...student,
// 	})
// })

// recentDataB.forEach((student, index) => {
// 	allData.push({
// 		key: `_${index}`,
// 		...student,
// 	})
// })
// // recentDataC.forEach((student, index) => {
// // 	allData.push({
// // 		key: `_${index}`,
// // 		...student,
// // 	})
// // })

// export default allData

// const retrieveRows = async (source) => {
// 	const jsonData = await import(`./data/feb2024/${source}.json`);
// 	return jsonData.map((student, index) => ({
// 	  key: `_${index}`,
// 	  ...student,
// 	}));
//   };
  
//   const recentDataSources = ['fasilkom', 'feb', 'ff', 'fmipa'];
  
//   const getAllStudentRows = async () => {
// 	const allData = await Promise.all(recentDataSources.map(retrieveRows));
// 	return allData.flat();
//   };
  
//   export default getAllStudentRows;
  

import rows_fk from './data/feb2024/fk.js';
import rows_fkg from './data/feb2024/fkg.js';
import rows_fkm from './data/feb2024/fkm.js';
import rows_fik from './data/feb2024/fik.js';
import rows_ff from './data/feb2024/ff.js';
import rows_fmipa from './data/feb2024/fmipa.js';
import rows_fasilkom from './data/feb2024/fasilkom.js';
import rows_ft from './data/feb2024/ft.js';
import rows_feb from './data/feb2024/feb.js';
import rows_fib from './data/feb2024/fib.js';
import rows_fisip from './data/feb2024/fisip.js';
import rows_fia from './data/feb2024/fia.js';
import rows_fh from './data/feb2024/fh.js';
import rows_fpsi from './data/feb2024/fpsi.js';
import rows_vok from './data/feb2024/vok.js';
import rows_sksg from './data/feb2024/sksg.js';
import rows_sil from './data/feb2024/sil.js';
import simak_2024 from './data/simak-2024.js'

const allData = [
	// Add more imports and mappings as needed
	...rows_fk.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fkg.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fkm.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fik.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_ff.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fmipa.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fasilkom.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_ft.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_feb.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fib.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fisip.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fia.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fh.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_fpsi.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_vok.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_sksg.map((student, index) => ({ key: `_${index}`, ...student })),
	...rows_sil.map((student, index) => ({ key: `_${index}`, ...student })),
	...simak_2024.map((student, index) => ({ key: `_${index}`, ...student })),
];

export default allData;
